var map = {
	"./Home": [
		2882,
		882
	],
	"./Home/": [
		2882,
		882
	],
	"./Home/index": [
		2882,
		882
	],
	"./Home/index.tsx": [
		2882,
		882
	],
	"./PrivacyPolicy": [
		8257,
		257
	],
	"./PrivacyPolicy.tsx": [
		8257,
		257
	],
	"./TermsConditions": [
		6620,
		620
	],
	"./TermsConditions.tsx": [
		6620,
		620
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;